export default __webpack_public_path__ + "static/media/document.833774f1.svg";